import React from 'react'
import styled from 'styled-components'

import { Box } from '@usap/uicomponents'

export const Container = styled(Box)`
  align-items: center; 
  flex-direction: row;
  padding: ${({ dashboard, isWmoEnabled, isMembershipCard }) => isWmoEnabled ? (isMembershipCard ? '32px 12px' : '32px 16px') : (dashboard ? '16px 8px' : '0px')};
  margin-top: ${props => (props.dashboard ? '0px' : '16px')};
  margin-bottom: ${props => (props.dashboard ? '0px' : '16px')};
  border: solid 1px ${props => (props.dashboard ? '#E0E0E0' : 'transparent')};
  border-radius:  ${props => (props.isWmoEnabled ? '4px' : '')};
  order: ${props => props.order || 'unset'};
  position:  ${props => (props.isMembershipCard ? 'relative' : '')};
  @media (max-width: 767px) {
    padding: ${({ isWmoEnabled }) => isWmoEnabled ? '24px 16px' : '0px'};
  }
`

export const IconBox = styled(Box)`
  padding:  ${props => props.isWmoEnabled ? '0px' : '16px'};
  border: ${props => props.isWmoEnabled ? "none" : 'solid 1px #E0E0E0'};
  align-items: center;
  justify-content: center;
  height: ${props => props.boxSize || '58px'};
  width: ${props => props.boxSize || '58px'};
  border-radius: 50%;
  margin-right: ${props => props.isWmoEnabled ? '12px' : '8px'};
`